<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-500 align-top">
      <div class="flex gap-4">
        <div class="flex-none">
          <img :src="emailTemplate.preview_url" class="w-24 rounded border" />
        </div>
        <div class="flex-1">
          <RouterLink
            :to="{
              name: 'accounts.accountId.emailTemplates.emailTemplateId.edit',
              params: {
                accountId: emailTemplate.account_id,
                emailTemplateId: emailTemplate.id,
              },
            }"
          >
            {{ emailTemplate.name }}
          </RouterLink>
        </div>
      </div>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 text-right align-top">
      <span class="whitespace-nowrap">{{ createdAt }}</span>
      <div>
        {{ createdAtFromNow }}
      </div>
    </td>
    <td class="w-0 align-top p-4">
      <MoreAction
        v-if="$membershipHasPermissionTo(['create email templates', 'delete email templates'])"
        :email-template="emailTemplate"
        @duplicated="$emit('duplicated')"
        @deleted="$emit('deleted')"
      />
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import MoreAction from './MoreAction.vue';

export default {
  components: { MoreAction },
  props: {
    emailTemplate: {
      type: Object,
      required: true,
    },
  },
  computed: {
    createdAt() {
      return moment.utc(this.emailTemplate.created_at).local().format('DD-MM-YYYY HH:mm');
    },
    createdAtFromNow() {
      return moment.utc(this.emailTemplate.created_at).local().fromNow();
    },
  },
};
</script>
